import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { toPascalCase } from '@cli-utils/text.js'
import { getTabNestedFields } from './get-tab-nested-fields.js'

export function collectTabIconNames(fields: SchemaField[]): string[] {
  const icons = new Set<string>()

  function collect(fieldsToCheck: SchemaField[]): void {
    for (const field of fieldsToCheck) {
      if (field.fields) collect(field.fields)
      if (field.tabs) {
        for (const tab of field.tabs) {
          const icon = tab.icon?.trim()
          if (icon) icons.add(toPascalCase(icon))
          collect(getTabNestedFields(tab))
        }
      }
    }
  }

  collect(fields)
  return Array.from(icons)
}
